import styled, { css, keyframes } from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const ghost = keyframes `
  50% {
    background-color: transparent;
  }
`;
export const buildLoader = ({ borderWidth, primaryColor, secondaryColor, }) => css `
  border: ${borderWidth} solid ${primaryColor};
  border-bottom-color: ${secondaryColor};
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;
export const buildForButtonLoader = ({ color }) => css `
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  border-radius: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
  background-color: ${color};
  animation-name: ${ghost};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-delay: 0.4s;

  &::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    background-color: ${color};
    position: absolute;
    margin-left: -1rem;
    animation-name: ${ghost};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  &::after {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    background-color: ${color};
    position: absolute;
    margin-left: 1rem;
    animation-name: ${ghost};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-delay: 0.8s;
  }
`;
export const LoaderStyled = styled.span `
  ${props => getStyles(props.styles.container)}
  ${({ $width }) => $width &&
    css `
      width: ${$width};
      height: ${$width};
    `};
  ${({ position }) => position &&
    css `
      position: ${position};
    `};
  ${({ styles }) => css `
    ${styles.animation}
  `}
  ${({ styles }) => styles.animation_loader &&
    buildLoader({
        borderWidth: styles.animation_loader.border_width,
        primaryColor: styles.animation_loader.primary_color,
        secondaryColor: styles.animation_loader.secondary_color,
    })}
  ${({ styles }) => styles.animation_button_loader &&
    buildForButtonLoader({
        color: styles.animation_button_loader.color,
    })}
`;
export const LoaderWrapperStyled = styled.span `
  display: flex;
  ${props => getStyles(props.styles.parentContainer)}
`;
//# sourceMappingURL=loader.styled.js.map